<app-page-header title="Home" titleLink="/reports" active_item="Comissões">
</app-page-header>
<form [formGroup]="comissao">
  <div class="row">
    <h5>{{ "common.commissions" | translate }}</h5>
    <div class="col-md-12 col-xl-12">
      <div
        class="card sales-summary shadow"
        [ngClass]="{
          'rounded-10': !isFilterColapsed,
          'rounded-10-top': isFilterColapsed
        }"
      >
        <div class="card-header">
          <div class="card-title mb-0">{{ "common.filters" | translate }}</div>
          <div class="card-options">
            <a
              href="javascript:void(0)"
              class="card-options-collapse"
              data-bs-toggle="card-collapse"
              (click)="filterColapse()"
              [attr.aria-expanded]="!isFilterColapsed"
              ><i
                class="fe fe-chevron-{{ !isFilterColapsed ? 'up' : 'down' }}"
              ></i
            ></a>
          </div>
        </div>
        <div
          class="card-body filter-extrato"
          [(ngbCollapse)]="isFilterColapsed"
        >
          <div class="row">
            <div class="col-xl-4 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtDescricao" class="form-label">{{
                  "common.search" | translate
                }}</label>
                <div class="input-icon-container">
                  <input
                    class="form-control"
                    type="text"
                    name="descricao"
                    id="txtDescricao"
                    bindValue="value"
                    [formControl]="comissao.controls.responsavel"
                  />
                  <i class="fe fe-clipboard input-icon btn-color" (click)="paste()"></i>
                </div>
              </div>
            </div>
            <div class="col-xl-1 col-lg-6 col-sm-6">
              <button
                type="button"
                class="our-button btn btn-pill btn-primary"
                (click)="buscar()"
              >
                <i class="fe fe-search me-2"></i
                >{{ "common.searchButton" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loading-extrato" *ngIf="!isLoaded">
      <div class="dimmer active">
        <div class="lds-ring">
          <div></div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card sales-summary rounded-10 shadow">
        <div class="card-header">
          <div class="card-title mb-0">{{ "common.history" | translate }}</div>
          <div class="card-options"></div>
        </div>
        <div class="card-body button-table">
          <app-table-commissions-wallet
            (transactionsLoaded)="onTransactionsLoaded($event)"
          >
          </app-table-commissions-wallet>
        </div>
      </div>
    </div>
  </div>
</form>
